export default __webpack_public_path__ + "static/media/evo-img.540d87e2.png";